import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'UserInfo'
}
const methods = [
    'AddItem',
    'InsertUser',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetAllItems',
    'UserLogin',
    'GetUserByLoginInfo',
    'ChangePassword',
    'UserLoginExt',
    'GetUserAuth',
    'GetUserAuthWithPsw',
    'UpdateUserEnable',
    'ResetPassword'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const UserApi = ZJApi.defineNewApi('UserApi', factory)

export default UserApi